import { render, staticRenderFns } from "./multiplayer-page.vue?vue&type=template&id=578e2d62&"
import script from "./multiplayer-page.vue?vue&type=script&lang=js&"
export * from "./multiplayer-page.vue?vue&type=script&lang=js&"
import style0 from "./multiplayer-page.vue?vue&type=style&index=0&id=578e2d62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports